import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);
import Model from "~/models/_Model";
import System from "./System";
import Schedule from "./Schedule";
import Log from "./Log";

export default class Task extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/systemsmanager";
  }

  // Set the resource route of the model
  resource() {
    return "tasks";
  }

  relations() {
    return {
      system: System,
      schedules: Schedule,
      logs: Log,
    };
  }

  get display_status_icon() {
    switch (this.status) {
      case "Error":
        return "error";
      default:
        return "check";
    }
  }

  get display_status_color() {
    switch (this.status) {
      case "Running":
        return "positive";
      case "Error":
        return "negative";
      default:
        return "info";
    }
  }

  get display_active_icon() {
    return this.active ? "check" : "error";
  }

  get display_active_color() {
    return this.active ? "positive" : "negative";
  }

  get display_last_run() {
    if (!this.last_run) {
      return "";
    }
    const last_run = dayjs(this.last_run);
    return `${last_run.format(
      "MM/DD/YYYY @ h:mm:ss A"
    )} (${last_run.fromNow()})`;
  }

  get display_next_run() {
    if (!this.next_run) {
      return "";
    }
    const next_run = dayjs(this.next_run);
    return `${next_run.format(
      "MM/DD/YYYY @ h:mm:ss A"
    )} (${next_run.fromNow()})`;
  }
}
